import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
export const tableConfig = {
    selection: false,
    height: 357,
    searchFields: [
        {
            name: '客户',
            value: 'customerName',
            type: 'advanceMulti',
            isFixed: true,
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'ebcuNameEn', value: '英文名称' },
                { prop: 'customerShortName', value: '客户简称' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            // 'ebcuEbplCountryCode','ebcuEbplProvinceCode','ebcuEbplCityCode','ebcuDistricts'
            cbParams: ['customerName', 'customerCode'],
            method: 'post',
            span: 5,
            // eslint-disable-next-line no-magic-numbers
            pageSizes: [50, 100, 250, 500, 1000],
            visible: true,
            rule: [
                { required: true, message: '客户名称不能为空', trigger: 'change' }
            ],
            opsUnlockType: 'advanceMulti'
        },
        {
            name: '客户分类',
            value: 'ebcuCustomerTypeList',
            type: 'select',
            optionNum: 'EBCU_CUSTOMER_TYPE_OVERSEAS',
            multiple: true,
            isFixed: true,
            span: 4
        },
        {
            name: '内外销',
            value: 'isImpExpCustomerList',
            type: 'select',
            optionNum: 'IS_IMP_EXP_CUSTOMER',
            multiple: true,
            isFixed: true,
            span: 4
        },
        {
            name: '大航线',
            value: 'routeCodes',
            type: 'select',
            optionNum: 'SYS_ROUTE_TYPE',
            multiple: true,
            isFixed: true,
            span: 4
        }
        // {
        //     name: '国家',
        //     value: 'ebcuEbplCountryName',
        //     type: 'input',
        //     isFixed: true,
        //     span: 3
        // }
    ],
    columns: [
        {
            label: '单据编码',
            prop: 'billCode',
            type: 'slot',
            minWidth: 120
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            minWidth: 120
        },
        {
            label: '客户名称',
            prop: 'customerName',
            minWidth: 200
        },
        {
            label: '客户英文名',
            prop: 'ebcuNameEn',
            minWidth: 200
        },
        {
            label: '客户简称',
            prop: 'customerShortName',
            minWidth: 120
        },
        {
            label: '注册国家',
            prop: 'ebcuEbplCountryName',
            minWidth: 100
        },
        {
            label: '省份',
            prop: 'ebcuEbplProvinceName',
            minWidth: 120
        },
        {
            label: '市',
            prop: 'ebcuEbplCityName',
            minWidth: 90
        },
        {
            label: '县区',
            prop: 'ebcuDistrictsName',
            minWidth: 90
        },
        {
            label: '地址',
            prop: 'ebcuAddress',
            minWidth: 90
        },
        {
            label: '内外销',
            prop: 'isImpExpCustomer',
            type: 'select',
            optionsKey: 'IS_IMP_EXP_CUSTOMER',
            minWidth: 90
        },
        {
            label: '客户分类',
            prop: 'ebcuCustomerType',
            type: 'select',
            optionsKey: 'EBCU_CUSTOMER_TYPE_OVERSEAS',
            minWidth: 90
        },
        {
            label: '销售产品',
            prop: 'salesProduct',
            minWidth: 80
        },
        {
            label: '是否涉及危险品',
            prop: 'isHazardous',
            type: 'select',
            optionsKey: 'SYS_IS_HAZARDOUS',
            minWidth: 160
        },
        {
            label: '预计合作规模（万元）',
            prop: 'estimatedScale',
            minWidth: 160
        },
        {
            label: '预计采购毛利率(%)',
            prop: 'estimatedGrossMargin',
            minWidth: 120
        },
        {
            label: '总账期（天）',
            prop: 'creditPeriodDays',
            minWidth: 90
        },
        {
            label: '投标押金(万元)',
            prop: 'tenderDeposit',
            minWidth: 90
        },
        {
            label: '运作押金(万元)',
            prop: 'operationDeposit',
            minWidth: 80
        },
        {
            label: '大航线',
            prop: 'routeCodes',
            type: 'custom',
            // type: 'select',
            // multiple: true,
            // optionsKey: 'SYS_ROUTE_TYPE',
            minWidth: 160
        },
        {
            label: '所属部门',
            prop: 'departmentName',
            minWidth: 160
        },
        {
            label: '审批状态',
            prop: 'approvalStatus',
            type: 'select',
            optionsKey: 'SYS_SU_MIP_AUDIT_STATUS',
            minWidth: 160
        },
        {
            label: '审批时间',
            prop: 'approvalTime',
            minWidth: 160
        },
        {
            label: '创建人',
            prop: 'createUserName',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '删除',
                event: 'delete',
                displayRule: (row) => {
                    const auth = otherUtils.getHasAuth(
                        btnAuthority.customerIntroduction.delete
                    );
                    // 没有关联流程信息或者关联的流程信息的状态 = 草稿时
                    return auth && ['', null, undefined, '1'].includes(row.approvalStatus?.toString());
                }
            },
            {
                label: '提交审批',
                event: 'change',
                displayRule: (row) => {
                    const auth = otherUtils.getHasAuth(
                        btnAuthority.customerIntroduction.approval
                    );
                    // 没有关联流程信息或者关联的流程信息的状态 = 草稿时
                    return auth && ['', null, undefined, '1', '5', '6'].includes(row.approvalStatus?.toString());
                }
            }
        ]
    }
};
